// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3yrXe","dragIcon":"Choice_dragIcon__1vxFK","left":"Choice_left__M-KBz","input":"Choice_input__2XCo9"};